import { useGuestPayorPaymentRequestDetails } from '@melio/ar-domain';
import { useFundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

import { PayByBankAccountScreen } from './screens';

type PayByBankActivityProps = {
  onDone: VoidFunction;
  fundingSourceId: string;
  paymentRequestLink: string;
};

export const PayByBankActivity = forwardRef<PayByBankActivityProps>(
  ({ paymentRequestLink, onDone, fundingSourceId }, ref) => {
    const { data: paymentRequestDetails, isLoading: isLoadingPaymentRequestLink } = useGuestPayorPaymentRequestDetails({
      paymentRequestLink,
    });
    const { data: fundingSource, isLoading: isLoadingFundingSource } = useFundingSource({ id: fundingSourceId });

    const handleOnSubmit = () => {
      // call pay invoice API

      onDone();
    };

    return (
      <PayByBankAccountScreen
        onSubmit={handleOnSubmit}
        fundingSourceName={fundingSource?.displayName}
        isSaving={isLoadingFundingSource || isLoadingPaymentRequestLink}
        amount={paymentRequestDetails?.invoice.totalAmount || 0}
        ref={ref}
      />
    );
  }
);
PayByBankActivity.displayName = 'PayByBankActivity';
